import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Radio } from 'lucide-react';
import { api } from '../lib/api';
import { VerifiedBadge } from './VerifiedBadge';

export function FavoriteShops() {
  const [shops, setShops] = useState([]);
  useEffect(() => { api.get('/me/followed-sellers').then(({ data }) => setShops(data)).catch(() => {}); }, []);
  return (
    <div className="card-elev rounded-2xl p-4" data-testid="favorite-shops">
      <div className="font-display font-bold flex items-center gap-2 text-sm"><Heart className="h-4 w-4 text-rose-400" fill="currentColor" />Mes boutiques favorites</div>
      {shops.length === 0 ? (
        <p className="mt-2 text-xs text-slate-400" data-testid="favorite-shops-empty">Cliquez « Suivre » sur une boutique pour être alertée dès qu'elle passe en live.</p>
      ) : (
        <ul className="mt-2 space-y-1.5">
          {shops.map((s) => (
            <li key={s.user_id} data-testid={`fav-shop-${s.user_id}`} className="flex items-center justify-between gap-2 text-sm">
              <Link to={`/seller/${s.user_id}`} className="flex items-center gap-1.5 hover:text-amber-400 truncate">{s.name}<VerifiedBadge verified={s.verified} testId={`fav-verified-${s.user_id}`} /></Link>
              {s.live_id && (
                <Link to={`/live/${s.live_id}`} data-testid={`fav-live-${s.user_id}`} className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full bg-red-600 text-white">
                  <Radio className="h-3 w-3" />EN LIVE
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
